// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import VueAxios from "vue-axios";
import axios from "axios";
import MetaInfo from 'vue-meta-info'
import ElementUI from "element-ui";
import querystring from "querystring";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "element-ui/lib/theme-chalk/index.css";
import 'magnific-popup/dist/magnific-popup.css';
import '@/style/style.scss';
import "swiper/dist/css/swiper.css";
import "./utils/global-mixin";
 
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(VueAxios, axios);
Vue.use(MetaInfo);
Vue.use(VueAwesomeSwiper);

Vue.prototype.$qs = querystring;
Vue.prototype.$https = axios;
window.$ = require('jquery');
require('magnific-popup');

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js